import { useQuery } from 'react-query';
import {
  authenticateUserApi,
  getAuthApiRequestParams,
} from '../services/AuthService';

export const useAuthenticateUserApi = (
  phone: string,
  action: string,
  language: string,
  newauth: boolean,
  otp?: string,
  partnerId?: string,
  screenName?: string,
  tokenForLoginSkip?: string
) => {
  const requestParams = getAuthApiRequestParams(
    phone,    
    action,   
    language, 
    newauth,  
    otp,      
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    partnerId,
    screenName,
    tokenForLoginSkip
  );

  const { refetch, data, isLoading, error } = useQuery({
    queryKey: ['authenticateUserApi', requestParams],
    queryFn: async () => {
      try {
        return await authenticateUserApi(requestParams);
      } catch (err) {
        console.log(`Authentication failed: ${(err as any)?.message}`);
      }
    },
    staleTime: 0,
    enabled: false,
  });

  return {
    authResponse: data,
    isLoading,
    error,
    refetch,
  };
};
